"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const tag_hoc_1 = require("tag-hoc");
exports.MarkdownDiv = styled_components_1.default(tag_hoc_1.default(["grid", "start", "end"])("div")) `
  @media (min-width: 480px) {
    display: ${props => props.grid ? 'grid' : 'block'};
  }
  ${props => props.grid ? 'grid-template-columns: repeat(12, 1fr);' : ''}
  ${props => props.grid ? 'grid-gap: 16px;' : ''}
  ${props => props.start ? `grid-column-start: ${props.start};` : ''}
  ${props => props.end ? `grid-column-end: ${props.end}` : ''}
`;
//# sourceMappingURL=markdown-div.js.map